module.exports = __webpack_public_path__ + "static/media/paper-self-funded.16e81137.png";